import React from "react";
import { Link } from "react-router-dom";

export type QuickAccessItem = {
  name: string;
  desc: string;
  actions: {
    label: string;
    link: string;
    variant?: "primary" | "outline";
    withSearchIcon?: boolean;
    width?: number;
  }[];
};

type QuickAccessProps = {
  items: QuickAccessItem[];
};

export default function QuickAccess({ items }: QuickAccessProps) {
  return (
    <div className="row g-4">
      {items.map((item, i) => (
        <div className="col-12 col-xl-6" key={i}>
          <div className="card h-100 border-0" style={{ borderRadius: "12px" }}>
            <div
              className="card-body d-flex justify-content-between align-items-center"
              style={{ padding: "20px 16px", minHeight: "140px" }}
            >
              <div style={{ maxWidth: "280px" }}>
                <h6 style={{ fontSize: "20px", lineHeight: "24px", color: "#3A4355", marginBottom: "4px" }} className="fw-bold">
                  {item.name}
                </h6>
                <p style={{ fontSize: "13px", lineHeight: "18px", color: "#7A8499" }} className="mb-0">
                  {item.desc}
                </p>
              </div>

              <div className="d-flex align-items-center gap-2">
                {item.actions.map((action, actionIndex) => (
                  <Link
                    key={`${action.label}-${actionIndex}`}
                    to={action.link}
                    className="btn"
                    style={{
                      borderRadius: "6px",
                      width: action.width ? `${action.width + 30}px` : "auto",
                      height: "30px",
                      padding: "4px 11px",
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: action.variant === "outline" ? "#009FE3" : "#FFFFFF",
                      backgroundColor: action.variant === "outline" ? "#FFFFFF" : "#009FE3",
                      border: "1px solid #009FE3",
                      whiteSpace: "nowrap",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    {action.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

